import {UiEvent, UiEventType} from '@web/middlewares/uiLogging'

/** 영역: MO, PC 순으로 확인 */
export const nClicksMap = new Map<UiEventType, [string, string]>([
    [UiEvent.SINGLE_COLUMN_HEADER_LOGO, ['ode.paylogo', 'ord.paylogo']],
    [UiEvent.SINGLE_COLUMN_HEADER_CLOSE, ['ode.close', 'ord.close']],
    [UiEvent.DELIVERY_ADDRESS_CHANGE_BUTTON, ['ode.addcha', 'ord.addcha']],
    [UiEvent.DELIVERY_VIRTUAL_PHONE_NUMBER_CHECKBOX, ['ode.safe', 'ord.safe']],
    [UiEvent.DELIVERY_VIRTUAL_PHONE_NUMBER_INFO, ['ode.safeinfo', 'ord.safeinfo']],
    [UiEvent.DELIVERY_INDIVIDUAL_MEMO_USE_CHECKBOX, ['ode.sepera', 'ord.sepera']],
    [UiEvent.DELIVERY_MEMO_SELECT, ['ode.click', 'ord.click']],
    [UiEvent.ORDERSHEET_DELIVERY_MEMO_REUSE_CHECKBOX, ['ode.memonext', 'ord.memonext']],
    [UiEvent.DELIVERY_MEMO, ['ode.delmemo', 'ord.delmemo']],
    [UiEvent.RECEIVER_TITLE_AREA, ['ode.recinfo', 'ord.recinfo']],
    [UiEvent.RECEIVER_INFO_AUTO_FILL, ['ode.adddefault', 'ord.adddefault']],
    [UiEvent.RECEIVER_INDIVIDUAL_MEMO_USE_CHECKBOX, ['ode.sepera', 'ord.sepera']],
    [UiEvent.RECEIVER_MEMO, ['ode.extramemo', 'ord.extramemo']],
    [UiEvent.PURCHASER_TITLE_AREA, ['ode.buyerinfo', 'ord.buyerinfo']],
    [UiEvent.PURCHASER_INFO_CHANGE, ['ode.now', 'ord.now']],
    [UiEvent.PRODUCT_TITLE, ['ode.prodinfo', 'ord.prodinfo']],
    [UiEvent.PRODUCT_THUMBNAIL, ['ode.image', 'ord.image']],
    [UiEvent.PRODUCT_NAME, ['ode.name', 'ord.name']],
    [UiEvent.PRODUCT_SELECT_IMMEDIATE_COUPON_ITEM, ['ode.disco', 'ord.disco']],
    [UiEvent.PRODUCT_CANCEL_IMMEDIATE_COUPON_ITEM, ['ode.nodis', 'ord.nodis']],
    [UiEvent.PRODUCT_SELECT_ADDITIONAL_COUPON_ITEM, ['ode.adddisco', 'ord.adddisco']],
    [UiEvent.PRODUCT_CANCEL_ADDITIONAL_COUPON_ITEM, ['ode.noadddis', 'ord.noadddis']],
    [UiEvent.PRODUCT_SELECT_STORE_COUPON_ITEM, ['ode.stodisco', 'ord.stodisco']],
    [UiEvent.PRODUCT_CANCEL_STORE_COUPON_ITEM, ['ode.nostodis', 'ord.nostodis']],
    [UiEvent.PRODUCT_SELECT_DELIVERY_COUPON_ITEM, ['ode.dlvdisco', 'ord.dlvdisco']],
    [UiEvent.PRODUCT_CANCEL_DELIVERY_COUPON_ITEM, ['ode.nodlvdis', 'ord.nodlvdis']],
    [UiEvent.PRODUCT_SELECT_NAVER_COUPON_ITEM, ['ode.navdisco', 'ord.navdisco']],
    [UiEvent.PRODUCT_CANCEL_NAVER_COUPON_ITEM, ['ode.nonavdis', 'ord.nonavdis']],
    [UiEvent.MERCHANT_PRODUCT_COUPON_SELECT, ['ode.selectdisco', 'ord.selectdisco']],
    [UiEvent.DUPLICATED_PRODUCT_COUPON_SELECT, ['ode.selectadddisco', 'ord.selectadddisco']],
    [UiEvent.MANAGER_PRODUCT_COUPON_SELECT, ['ode.selectnavdisco', 'ord.selectnavdisco']],
    [UiEvent.DELIVERY_COUPON_SELECT, ['ode.selectdlvdisco', 'ord.selectdlvdisco']],
    [UiEvent.STORE_COUPON_SELECT, ['ode.selectstodisco', 'ord.selectstodisco']],
    [UiEvent.POINT_PAYMENT_OPEN_TOOLTIP, ['ode.pointinfo', 'ord.pointinfo']],
    [UiEvent.POINT_PAYMENT_INPUT_BLUR, ['ode.point', 'ord.point']],
    [UiEvent.POINT_PAYMENT_INPUT_CLEAR, ['ode.clearpoi', 'ord.clearpoi']],
    [UiEvent.POINT_PAYMENT_USE_ALL, ['ode.allpoi', 'ord.allpoi']],
    [UiEvent.POINT_PAYMENT_USE_ALL_ON, ['ode.alwaysallpoi', 'ord.alwaysallpoi']],
    [UiEvent.POINT_PAYMENT_USE_ALL_OFF, ['ode.noalwallpoi', 'ord.noalwallpoi']],
    [UiEvent.POINT_PAYMENT_SHOW_AFFILIATE_POINT, ['ode.pointswap', 'ord.pointswap']],
    [UiEvent.POINT_PAYMENT_SHOW_AFFILIATE_POINT_FIND, ['ode.pntcheck', 'ord.pntcheck']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_JOIN, ['ode.joinpaylater', 'ord.joinpaylater']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_USE_ON, ['ode.onpaylater', 'ord.onpaylater']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_USE_OFF, ['ode.offpaylater', 'ord.offpaylater']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_INPUT_CLEAR, ['ode.clearpaylater', 'ord.clearpaylater']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_REDEEM, ['ode.paylateroverduepaynow', 'ord.paylateroverduepaynow']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_USE_ALL, ['ode.allpaylater', 'ord.allpaylater']],
    [UiEvent.POINT_PAYMENT_PAY_LATER_NOT_CANDIDATE_USE, ['ode.notifypaylater', 'ord.notifypaylater']],

    [UiEvent.PAYMENT_METHOD_NOTICE, ['ode.eventtext', 'ord.eventtext']],
    [UiEvent.PAYMENT_METHOD_CONNECT_RECHARGING_ACCOUNT, ['ode.addaccount', 'ord.addaccount']],
    [UiEvent.PAYMENT_METHOD_TITLE, ['ode.payinfo', 'ord.payinfo']],
    [UiEvent.PAYMENT_METHOD_PAYMONEY_ON, ['ode.chargepointon', 'ord.chargepointon']],
    [UiEvent.PAYMENT_METHOD_COMPLEX_PAYMONEY_PAYMENT_OFF, ['ode.chargepointoff', 'ord.chargepointoff']],
    [UiEvent.PAYMENT_METHOD_RECHARGING_POINT_ON, ['ode.chargepointon', 'ord.chargepointon']],
    [UiEvent.PAYMENT_METHOD_COMPLEX_PAYMENT_OFF, ['ode.chargepointoff', 'ord.chargepointoff']],
    [UiEvent.PAYMENT_METHOD_PAYMONEY_AMOUNT, ['ode.chargepointamount', 'ord.chargepointamount']],
    [UiEvent.PAYMENT_METHOD_PAYMONEY_ACCOUNT, ['ode.chargeaccount', 'ord.chargeaccount']],
    /** 1.0 / 3.0 계정 대상 출금계좌 선택 */
    [UiEvent.PAYMENT_METHOD_RECHARGING_AMOUNT, ['ode.chargepointamount', 'ord.chargepointamount']],
    [UiEvent.PAYMENT_METHOD_RECHARGING_ACCOUNT, ['ode.chargeaccount', 'ord.chargeaccount']],
    [
        UiEvent.PAYMENT_METHOD_ADD_PAYMONEY_RECHARGING_ACCOUNT,
        ['ode.chargepointaccountadd', 'ord.chargepointaccountadd'],
    ],
    [UiEvent.PAYMENT_METHOD_RECHARGE_PROMOTION_BANNER, ['ode.chargepointguidebanner', 'ord.chargepointguidebanner']],
    [UiEvent.PAYMENT_METHOD_EASY_ACCOUNT_ON, ['ode.simpleaccount', 'ord.simpleaccount']],
    [UiEvent.PAYMENT_METHOD_ADD_EASY_ACCOUNT, ['ode.addsimacc', 'ord.addsimacc']],
    [UiEvent.PAYMENT_METHOD_SWIPE_EASY_ACCOUNT, ['ode.simaccswipe', 'ord.simaccswipe']],
    [UiEvent.PAYMENT_METHOD_EASY_CARD_ON, ['ode.simplecard', 'ord.simplecard']],
    [UiEvent.PAYMENT_METHOD_SWIPE_EASY_CARD, ['ode.simcardswipe', 'ord.simcardswipe']],
    [UiEvent.PAYMENT_METHOD_ADD_EASY_CARD, ['ode.addsimcard', 'ord.addsimcard']],
    [UiEvent.PAYMENT_METHOD_NORMAL_PAY_ON, ['ode.paygeneral', 'ord.paygeneral']],
    [UiEvent.PAYMENT_METHOD_FAMILY_PAY_ON, ['ode.familypay', 'ord.familypay']],
    [UiEvent.PAYMENT_METHOD_FAMILY_PAY_MESSAGE_ON, ['ode.familypaymessage', 'ord.familypaymessage']],
    [UiEvent.PAYMENT_METHOD_CREDIT_CARD_ON, ['ode.card', 'ord.card']],
    [UiEvent.PAYMENT_METHOD_MOBILE_ON, ['ode.cellphone', 'ord.cellphone']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_ON, ['ode.deposit', 'ord.deposit']],
    // 삼성페이가 없음 확인 필요
    [UiEvent.PAYMENT_METHOD_SAMSUNG_PAY_ON, ['ode.samsungpay', 'ord.samsungpay']],
    [UiEvent.PAYMENT_METHOD_PAY_LATER_BANNER, ['ode.cellphonepaylaterbanner', 'ord.cellphonepaylaterbanner']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_SELECT_ON, ['ode.ploption', 'ord.ploption']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_TOOLTIP, ['ode.plmean', 'ord.plmean']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_TIMELINE, ['ode.timeline', 'ord.timeline']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_ADD_ACCOUNT, ['ode.adspaccount', 'ord.adspaccount']],
    [UiEvent.PAYMENT_METHOD_PAY_NEXT_ADD_CARD, ['ode.adspcard', 'ord.adspcard']],
    [UiEvent.PAYMENT_METHOD_ADD_RECHARGING_ACCOUNT, ['ode.chargepointaccountadd', 'ord.chargepointaccountadd']],
    [UiEvent.PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_CLOSE, ['ode.closelayer', 'ord.closelayer']],
    [UiEvent.PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_BUTTON, ['ode.placcount', 'ord.placcount']],
    [UiEvent.PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_WEEK_CLOSE, ['ode.nolayer', 'ord.nolayer']],
    [
        UiEvent.PAYMENT_METHOD_SAMSUNG_PAY_PAY_MONEY_BANNER,
        ['ode.general_chargepoint_samsungpay', 'ord.general_chargepoint_samsungpay'],
    ],
    [UiEvent.PAYMENT_METHOD_NO_PAYMENT, ['ode.paymentdimm', 'ord.paymentdimm']],
    [UiEvent.PAYMENT_METHOD_BENEFIT_INFO, ['ode.paybenefitinfo', 'ord.paybenefitinfo']],
    [UiEvent.PAYLATER_OVERDUE_REDEEM, ['ode.paylateroverdue', 'ord.paylateroverdue']],
    [UiEvent.PAYLATER_OVERDUE_CLOSE, ['ode.paylateroverdueclose', 'ord.paylateroverdueclose']],
    [UiEvent.ACCUMULATE_POINT_TOGGLE_BENEFIT_TOOLTIP, ['ode.beneinfo', 'ord.beneinfo']],
    [UiEvent.ACCUMULATE_POINT_TOGGLE_MEMBERSHIP_BENEFIT_TOOLTIP, ['ode.membershiphelp', 'ord.membershiphelp']],
    [UiEvent.ACCUMULATE_POINT_OPEN_REVIEW_TOOLTIP, ['ode.revinfo', 'ord.revinfo']],
    /** 멤버십 최초가입 배너, 토스트 */
    [UiEvent.ACCUMULATE_POINT_MEMBERSHIP_LINE_BANNER, ['ode.membershiplinebanner', 'ord.membershiplinebanner']],
    /** 멤버십 재가입 배너 */
    [
        UiEvent.ACCUMULATE_POINT_MEMBERSHIP_REJOIN_LINE_BANNER,
        ['ode.rejoinmembershiplinebanner', 'ord.rejoinmembershiplinebanner'],
    ],
    [
        UiEvent.ACCUMULATE_POINT_MEMBERSHIP_POPUP_BUTTON,
        ['ode.membershiplinebannerapply', 'ord.membershiplinebannerapply'],
    ],
    [UiEvent.ACCUMULATE_POINT_FAMILY_PAY_TOOLTIP_ON, ['ode.familypaypointinfo', 'ord.familypaypointinfo']],
    [UiEvent.ACCUMULATE_POINT_FAMILY_PAY_TOOLTIP_OFF, ['ode.familypaypointinfox', 'ord.familypaypointinfox']],
    [UiEvent.AGREEMENT_FAMILY_PAY, ['ode.familypayagreecheck', 'ord.familypayagreecheck']],
    [UiEvent.AGREEMENT_FAMILY_PAY_TOOLTIP_ON, ['ode.familypayagree', 'ord.familypayagree']],
    [UiEvent.AGREEMENT_FAMILY_PAY_TOOLTIP_OFF, ['ode.familypayagreex', 'ord.familypayagreex']],
    [UiEvent.AGREEMENT_FAMILY_PAY_MINOR_TOOLTIP_OFF, ['ode.familypayunder14x', 'ord.familypayunder14x']],
    [UiEvent.SUBMIT_CLICK_BUTTON, ['ode.pay', 'ord.pay']],
    [UiEvent.FLOATING_SUBMIT_CLICK_BUTTON, ['pay_float', 'pay_float']],
    [UiEvent.FLOATING_MODAL_ALCOHOL, ['floatmodal_alcohol', 'floatmodal_alcohol']],
    [UiEvent.FLOATING_MODAL_OVERSEAS, ['floatmodal_overseas', 'floatmodal_overseas']],
    [UiEvent.FLOATING_MODAL_CUSTOM, ['floatmodal_custom', 'floatmodal_custom']],
    [UiEvent.FLOATING_MODAL_PREORDER, ['floatmodal_preorder', 'floatmodal_preorder']],
    [UiEvent.FLOATING_MODAL_ESCROW, ['floatmodal_escrow', 'floatmodal_escrow']],
    [UiEvent.FLOATING_MODAL_DETAIL, ['floatmodal_detail', 'floatmodal_detail']],
    [UiEvent.FLOATING_MODAL_CLOSE, ['floatmodal_close', 'floatmodal_close']],
    [UiEvent.FLOATING_MODAL_OPEN, ['floatmodal_open', 'floatmodal_open']],
    [UiEvent.FLOATING_MODAL_SUBMIT_CLICK_BUTTON, ['floatmodal', 'floatmodal']],

    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_EDIT_BUTTON, ['ode.pccchange', 'ord.pccchange']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_INPUT_BUTTON, ['ode.pccinput', 'ord.pccinput']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_RADIO_ON, ['ode.pccyes', 'ord.pccyes']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_RADIO_OFF, ['ode.pccno', 'ord.pccno']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_REQUEST, ['ode.pccrequest', 'ode.pccrequest']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_VIEW, ['ode.pccview', 'ode.pccview']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_OPEN_UNIPASS, ['ode.pccopenunipass', 'ode.pccopenunipass']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_CALL, ['ode.pcccall', 'ode.pcccall']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_SAVE, ['ode.pccsave', 'ode.pccsave']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_GO_UNIPASS, ['ode.pccgounipass', 'ode.pccgounipass']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_MODIFY_ADDR, ['ode.pccmodifyaddr', 'ode.pccmodifyaddr']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_SAVE_ADDR, ['ode.pccsaveaddr', 'ode.pccsaveaddr']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_CONFIRM, ['ode.pccconfirm', 'ode.pccconfirm']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_AGREE_SAVE, ['ode.pccagreesave', 'ode.pccagreesave']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_CLOSE, ['ode.pccclose', 'ode.pccclose']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_FAILURE, ['ode.pccfailure', 'ode.pccfailure']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_FAILURE_SAVE, ['ode.pccfailuresave', 'ode.pccfailuresave']],

    [UiEvent.PAYMENT_METHOD_REGIST_FIRST_EASY_PAYMENT_METHOD, ['ode.firstsimplepay', 'ord.firstsimplepay']],
    [UiEvent.PAYMENT_METHOD_REGIST_FIRST_EASY_CARD, ['ode.firstsimplecard', 'ord.firstsimplecard']],
    [UiEvent.PAYMENT_METHOD_REGIST_FIRST_EASY_BANK, ['ode.firstsimpleaccount', 'ord.firstsimpleaccount']],
    [UiEvent.APPROVAL_FAIL_REORDER, ['fle.orderagain', 'fle.orderagain']],
    [UiEvent.APPROVAL_FAIL_GO_SHOPPING_HOME, ['fle.shophome', 'fle.shophome']],
    [UiEvent.APPROVAL_FAIL_PAYLATER_USE_BANNER_SHOW, ['fle.plmemapp', 'fle.plmemapp']],
    [UiEvent.APPROVAL_FAIL_PAYLATER_USE_BANNER_CLICK, ['fle.plmemclick', 'fle.plmemclick']],
    [UiEvent.APPROVAL_FAIL_PAYLATER_JOIN_BANNER_SHOW, ['fle.pljoinapp', 'fle.pljoinapp']],
    [UiEvent.APPROVAL_FAIL_PAYLATER_JOIN_BANNER_CLICK, ['fle.pljoinclick', 'fle.pljoinclick']],
    /** 후불결제 유도배너 */
    [UiEvent.HYUNDAI_FOCUSING_INDUCTION_BANNER_CLICK, ['ode.nhdcintro', 'ord.nhdcintro']],
    [UiEvent.HYUNDAI_CARD_TYPE_BANNER_CLICK, ['ode.nhdcplate', 'ord.nhdcplate']],
    [UiEvent.HYUNDAI_GET_BENEFIT_NOW_CLICK, ['ode.nhdcbenefit', 'ord.nhdcbenefit']],
    [UiEvent.SAMSUNG_TAPTAP_FOCUSING_INDUCTION_BANNER_CLICK, ['ode.ssttintro', 'ord.ssttintro']],
    [UiEvent.SAMSUNG_TAPTAP_CARD_TYPE_BANNER_CLICK, ['ode.ssttplate', 'ord.ssttplate']],
    [UiEvent.SAMSUNG_TAPTAP_GET_BENEFIT_NOW_CLICK, ['ode.ssttbenefit', 'ord.ssttbenefit']],
    [UiEvent.NAVERPAY_MONEY_FOCUSING_INDUCTION_BANNER_CLICK, ['ode.npmcintro', 'ord.npmcintro']],
    [UiEvent.NAVERPAY_MONEY_CARD_TYPE_BANNER_CLICK, ['ode.npmcplate', 'ord.npmcplate']],
    [UiEvent.NAVERPAY_MONEY_GET_BENEFIT_NOW_CLICK, ['ode.npmcbenefit', 'ord.npmcbenefit']],
    [UiEvent.PROMOTION_HYUNDAI_FOCUSING_INDUCTION_BANNER_CLICK, ['ode.nhdcintrocardpm', 'ord.nhdcintrocardpm']],
    [UiEvent.PROMOTION_HYUNDAI_CARD_TYPE_BANNER_CLICK, ['ode.nhdcplatecardpm', 'ord.nhdcplatecardpm']],
    [UiEvent.PROMOTION_HYUNDAI_GET_BENEFIT_NOW_CLICK, ['ode.nhdcbenefitcardpm', 'ord.nhdcbenefitcardpm']],
    [UiEvent.PROMOTION_LOTTE_FOCUSING_INDUCTION_BANNER_CLICK, ['ode.splcintrocardpm', 'ord.splcintrocardpm']],
    [UiEvent.PROMOTION_LOTTE_CARD_TYPE_BANNER_CLICK, ['ode.splcplatecardpm', 'ord.splcplatecardpm']],
    [UiEvent.PROMOTION_LOTTE_GET_BENEFIT_NOW_CLICK, ['ode.splcbenefitcardpm', 'ord.splcbenefitcardpm']],
    [UiEvent.PROMOTION_SHINHAN_FOCUSING_INDUCTION_BANNER_CLICK, ['ode.shlfintrocardpm', 'ord.shlfintrocardpm']],
    [UiEvent.PROMOTION_SHINHAN_CARD_TYPE_BANNER_CLICK, ['ode.shlfplatecardpm', 'ord.shlfplatecardpm']],
    [UiEvent.PROMOTION_SHINHAN_GET_BENEFIT_NOW_CLICK, ['ode.shlfbenefitcardpm', 'ord.shlfbenefitcardpm']],
    [UiEvent.PROMOTION_SAMSUNG_FOCUSING_INDUCTION_BANNER_CLICK, ['ode.ssttintrocardpm', 'ord.ssttintrocardpm']],
    [UiEvent.PROMOTION_SAMSUNG_CARD_TYPE_BANNER_CLICK, ['ode.ssttplatecardpm', 'ord.ssttplatecardpm']],
    [UiEvent.PROMOTION_SAMSUNG_GET_BENEFIT_NOW_CLICK, ['ode.ssttbenefitcardpm', 'ord.ssttbenefitcardpm']],
    [
        UiEvent.PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_FOCUSING_INDUCTION_BANNER_CLICK,
        ['ode.sskhintrocardpm', 'ord.sskhintrocardpm'],
    ],
    [UiEvent.PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_BANNER_CLICK, ['ode.sskhplatecardpm', 'ord.sskhplatecardpm']],
    [
        UiEvent.PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_GET_BENEFIT_NOW_CLICK,
        ['ode.sskhbenefitcardpm', 'ord.sskhbenefitcardpm'],
    ],
    [UiEvent.SHINHAN_LINE_FRIENDS_FOCUSING_INDUCTION_BANNER_CLICK, ['ode.shlfintro', 'ord.shlfintro']],
    [UiEvent.SHINHAN_LINE_FRIENDS_CARD_TYPE_BANNER_CLICK, ['ode.shlfplate', 'ord.shlfplate']],
    [UiEvent.SHINHAN_LINE_FRIENDS_GET_BENEFIT_NOW_CLICK, ['ode.shlfbenefit', 'ord.shlfbenefit']],
    [UiEvent.LOTTE_NPAY_LOCA_FOCUSING_INDUCTION_BANNER_CLICK, ['ode.splcintro', 'ord.splcintro']],
    [UiEvent.LOTTE_NPAY_LOCA_CARD_TYPE_BANNER_CLICK, ['ode.splcplate', 'ord.splcplate']],
    [UiEvent.LOTTE_NPAY_LOCA_GET_BENEFIT_NOW_CLICK, ['ode.splcbenefit', 'ord.splcbenefit']],
    /** 결제 FE 유효성검증 */
    [UiEvent.DELIVERY_INPUT_FAIL, ['ode.addrnone', 'ord.addrnone']],
    [UiEvent.DELIVERY_ADDRESS_NAME_MAX_FAIL, ['ode.delnameover', 'ord.delnameover']],
    [UiEvent.DELIVERY_RECEIVER_NAME_FAIL, ['ode.addrnamenone', 'ord.addrnamenone']],
    [UiEvent.DELIVERY_RECEIVER_NAME_MAX_FAIL, ['ode.addrnameover', 'ord.addrnameover']],
    [UiEvent.DELIVERY_DETAIL_ADDRESS_MAX_FAIL, ['ode.addrdtlover', 'ord.addrdtlover']],
    [UiEvent.DELIVERY_PHONE_NUMBER_FAIL, ['ode.addrphonediff1', 'ord.addrphonediff1']],
    [UiEvent.DELIVERY_PHONE_NUMBER_TWO_FAIL, ['ode.addrphonediff2', 'ord.addrphonediff2']],
    [UiEvent.DELIVERY_KOREA_ADDRESS_FAIL, ['ode.addrchar', 'ord.addrchar']],
    [UiEvent.DELIVERY_LOT_DETAIL_NONE, ['ode.jibundtlnone', 'ord.jibundtlnone']],
    [UiEvent.PERSONAL_CUSTOMS_CODE_FAIL, ['ode.cuscodeerr', 'ord.cuscodeerr']],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_CHECK_FAIL, ['ode.cuscodefalse', 'ord.cuscodefalse']],
    [UiEvent.RECEIVER_NAME_FAIL, ['ode.recnamenone', 'ord.recnamenone']],
    [UiEvent.RECEIVER_PHONE_NUMBER_FAIL, ['ode.recphonediff', 'ord.recphonediff']],
    [UiEvent.MEMO_MAX_FAIL, ['ode.memoover', 'ord.memoover']],
    [UiEvent.CASH_RECEIPT_PHONE_NUMBER_FAIL, ['ode.recephoneerr', 'ord.recephoneerr']],
    [UiEvent.CASH_RECEIPT_CARD_FAIL, ['ode.rececarderr', 'ord.rececarderr']],
    [UiEvent.CASH_RECEIPT_BUSINESS_REGISTRATION, ['ode.recebuserr', 'ord.recebuserr']],
    [UiEvent.PAY_MONEY_USING_FAIL, ['ode.chrpoierr', 'ord.chrpoierr']],
    [UiEvent.PAY_MONEY_DELETED, ['ode.paymoneyerr', 'ord.paymoneyerr']],
    [UiEvent.UNAVAILABLE_CHARGE_BANK, ['ode.chrpoitallins', 'ord.chrpoitallins']],
    [UiEvent.UNAVAILABLE_CHARGE_BANK_ACCOUNT, ['ode.chrpointaccins', 'ord.chrpointaccins']],
    [UiEvent.EMPTY_CHARGE_BANK, ['ode.chrpointaccnone', 'ord.chrpointaccnone']],
    [UiEvent.NONE_SELECTED_PAY_METHOD, ['ode.paynone', 'ord.paynone']],
    [UiEvent.EMPTY_EASY_CARD, ['ode.simplecardnone', 'ord.simplecardnone']],
    [UiEvent.EMPTY_EASY_BANK, ['ode.simpleaccnone', 'ord.simpleaccnone']],
    [UiEvent.UNAVAILABLE_EASY_BANK, ['ode.simpleaccins', 'ord.simpleaccins']],
    [UiEvent.NEED_CARD_CODE, ['ode.cardnone', 'ord.cardnone']],
    [UiEvent.CANT_USE_CARD, ['ode.carderr', 'ord.carderr']],
    [UiEvent.MOBILE_PHONE_NUMBER_FAIL, ['ode.cellphoneerr', 'ord.cellphoneerr']],
    [UiEvent.NEED_MOBILE_PASSWORD, ['ode.simcppwerr', 'ord.simcppwerr']],
    [UiEvent.VIRTUAL_ACCOUNT_BANK_CODE_FAIL, ['ode.banknone', 'ord.banknone']],
    [UiEvent.REFUND_ACCOUNT_CODE_FAIL, ['ode.bankrefnone', 'ord.bankrefnone']],
    [UiEvent.MINIMUM_MAXIMUM_AMOUNT_FAIL, ['ode.payinfoerr', 'ord.payinfoerr']],
    [UiEvent.MINIMUM_AMOUNT_FAIL, ['ode.minpayerr', 'ord.minpayerr']],
    [UiEvent.MAXIMUM_AMOUNT_FAIL, ['ode.maxpayerr', 'ord.maxpayerr']],
    [UiEvent.MAXIMUM_AMOUNT_FAIL_WITH_VIRTUAL_ACCOUNT_BANK, ['ode.accountover', 'ord.accountover']],
    [UiEvent.SELECT_ADDITIONAL_PAY_METHOD, ['ode.complexnone', 'ord.complexnone']],
    [UiEvent.FDS_PAYMENT_SECURITY, ['ode.paylimit', 'ord.paylimit']],
    [UiEvent.BLACK_CONSUMER, ['ode.blackconsumer', 'ord.blackconsumer']],
    [UiEvent.OPEN_BANKING_AGREED, ['ode.agrbanknone', 'ord.agrbanknone']],
    [UiEvent.AGREEMENT_THIRD_PEOPLE, ['ode.agrinfonone', 'ord.agrinfonone']],
    [UiEvent.AGREEMENT_CUSTOM_ORDER, ['ode.agrcusnone', 'ord.agrcusnone']],
    [UiEvent.AGREEMENT_PRE_ORDER, ['ode.agrresnone', 'ord.agrresnone']],
    [UiEvent.AGREEMENT_PERSONAL_DATA_CROSS_BORDER_TRANSFER, ['ode.agrseanone', 'ord.agrseanone']],
    [UiEvent.OVER_USING_AMOUNT, ['ode.usepoiover', 'ord.usepoiover']],
    [UiEvent.OVER_USING_REWARD_AMOUNT, ['ode.usebepoiover', 'ord.usebepoiover']],
    [UiEvent.OVER_USING_CHARGE_AMOUNT, ['ode.usechrpoiover', 'ord.usechrpoiover']],
    [UiEvent.OVER_PAY_LATER_AMOUNT, ['ode.useplover', 'ord.useplover']],
    [UiEvent.OVER_RECHARGING_AMOUNT, ['ode.chrpoiover', 'ord.chrpoiover']],
    [UiEvent.OUT_OF_STOCK, ['ode.purchaseerr', 'ord.purchaseerr']],
    [UiEvent.REGISTER_FIRST_EASY_PAYMENT, ['ode.simpleerr', 'ord.simpleerr']],
    [UiEvent.DEPRECATED_ZIPCODES, ['ode.zipabol', 'ord.zipabol']],
    [UiEvent.REJECT_SIX_DIGITS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_PRODUCT, ['ode.ziperr', 'ord.ziperr']],
    [UiEvent.COMMON_ENTRANCE_PASSWORD_GUIDE, ['ode.accmetdoornone', 'ord.accmetdoornone']],
    [UiEvent.PICKUP_LOCATION_GUIDE, ['ode.accesslocnone', 'ord.accesslocnone']],
    [UiEvent.PICKUP_LOCATION_NAME_MAX_FAIL, ['ode.accesslocover', 'ord.accesslocover']],
    [UiEvent.ENTRY_METHOD_GUIDE, ['ode.accmetetcnone', 'ord.accmetetcnone']],
    [UiEvent.ENTRY_METHOD_NAME_MAX_FAIL, ['ode.accmetetcover', 'ord.accmetetcover']],
    [UiEvent.ADDITIONAL_OPTIONS_FAIL, ['ode.optnone', 'ord.optnone']],
    [UiEvent.DELIVERY_MEMO_SETTING_BUTTON, ['ode.memosetting', 'ord.memosetting']],
    [UiEvent.DELIVERY_MEMO_DELETE_BUTTON, ['ode.memodelete', 'ord.memodelete']],
    [UiEvent.DELIVERY_INVALID_MODIFY_BUTTON, ['ode.zipcodechange', 'ord.zipcodechange']],
    /** 배송지관리 */
    [UiEvent.ORDERSHEET_ADDRESS_BOOK_BACK_BUTTON, ['ode.addrback', 'ord.addrback']],
    [UiEvent.RESULT_ADDRESS_BOOK_BACK_BUTTON, ['ctm.addrback', 'ctm.addrback']],
    [UiEvent.ORDERSHEET_ADDRESS_BOOK_ADD_BUTTON, ['ode.addrnew', 'ord.addrnew']],
    [UiEvent.RESULT_ADDRESS_BOOK_ADD_BUTTON, ['ctm.addrnew', 'ctm.addrnew']],
    [UiEvent.ORDERSHEET_ADDRESS_BOOK_ADDRESS, ['ode.addrselect', 'ord.addrselect']],
    [UiEvent.RESULT_ADDRESS_BOOK_ADDRESS, ['ctm.addrselect', 'ctm.addrselect']],
    [UiEvent.ORDERSHEET_ADDRESS_BOOK_EDIT_BUTTON, ['ode.addredit', 'ord.addredit']],
    [UiEvent.RESULT_ADDRESS_BOOK_EDIT_BUTTON, ['ctm.addredit', 'ctm.addredit']],
    [UiEvent.ORDERSHEET_ADDRESS_BOOK_REGISTER_BUTTON, ['ode.addrsave', 'ord.addrsave']],
    [UiEvent.RESULT_ADDRESS_BOOK_REGISTER_BUTTON, ['ctm.addrsave', 'ctm.addrsave']],
    [UiEvent.ORDERSHEET_ADDRESS_BOOK_DELETE_BUTTON, ['ode.addrdelete', 'ord.addrdelete']],
    [UiEvent.RESULT_ADDRESS_BOOK_DELETE_BUTTON, ['ctm.addrdelete', 'ctm.addrdelete']],
    [UiEvent.ORDERSHEET_ADDRESS_BOOK_SHOW_ALL_BUTTON, ['ode.addrmore', 'ord.addrmore']],
    [UiEvent.RESULT_ADDRESS_BOOK_SHOW_ALL_BUTTON, ['ctm.addrmore', 'ctm.addrmore']],
    [UiEvent.RESULT_ADDRESS_BOOK_CONFIRM_BUTTON, ['ctm.addrdone', 'ctm.addrdone']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_RECEIVER, ['ode.addrname', 'ord.addrname']],
    [UiEvent.RESULT_ADDRESS_FORM_RECEIVER, ['ctm.addrname', 'ctm.addrname']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_PHONE_NUMBER, ['ode.addrphone', 'ord.addrphone']],
    [UiEvent.RESULT_ADDRESS_FORM_PHONE_NUMBER, ['ctm.addrphone', 'ctm.addrphone']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_ADDITIONAL_PHONE_NUMBER, ['ode.addrphoneadd', 'ord.addrphoneadd']],
    [UiEvent.RESULT_ADDRESS_FORM_ADDITIONAL_PHONE_NUMBER, ['ctm.addrphoneadd', 'ctm.addrphoneadd']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_PRESET_HOME, ['ode.addrpresethome', 'ord.addrpresethome']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_HOME, ['ctm.addrpresethome', 'ctm.addrpresethome']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_PRESET_OFFICE, ['ode.addrpresetoffice', 'ord.addrpresetoffice']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_OFFICE, ['ctm.addrpresetoffice', 'ctm.addrpresetoffice']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_PRESET_SCHOOL, ['ode.addrpresetschool', 'ord.addrpresetschool']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_SCHOOL, ['ctm.addrpresetschool', 'ctm.addrpresetschool']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_PRESET_FRIEND, ['ode.addrpresetfriend', 'ord.addrpresetfriend']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_FRIEND, ['ctm.addrpresetfriend', 'ctm.addrpresetfriend']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_PRESET_FAMILY, ['ode.addrpresetfamily', 'ord.addrpresetfamily']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_FAMILY, ['ctm.addrpresetfamily', 'ctm.addrpresetfamily']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_PRESET_MANUAL, ['ode.addrpresetmanual', 'ord.addrpresetmanual']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_MANUAL, ['ctm.addrpresetmanual', 'ctm.addrpresetmanual']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_SEARCH_ADDRESS, ['ode.addrdelsearch', 'ord.addrdelsearch']],
    [UiEvent.RESULT_ADDRESS_FORM_SEARCH_ADDRESS, ['ctm.addrdelsearch', 'ctm.addrdelsearch']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_DETAIL_ADDRESS, ['ode.addrdetail', 'ord.addrdetail']],
    [UiEvent.RESULT_ADDRESS_FORM_DETAIL_ADDRESS, ['ctm.addrdetail', 'ctm.addrdetail']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_SET_AS_PRIMARY_CHECKBOX, ['ode.addrdefaultset', 'ord.addrdefaultset']],
    [UiEvent.RESULT_ADDRESS_FORM_SET_AS_PRIMARY_CHECKBOX, ['ctm.addrdefaultset', 'ctm.addrdefaultset']],
    [UiEvent.ORDERSHEET_ADDRESS_FORM_CONFIRM, ['ode.addrcheck', 'ord.addrcheck']],
    [UiEvent.RESULT_ADDRESS_FORM_CONFIRM, ['ctm.addrcheck', 'ctm.addrcheck']],
    [UiEvent.RESULT_VIRTUAL_PHONE_NUMBER_CHECKBOX, ['ctm.safe', 'ctm.safe']],
    [UiEvent.RESULT_VIRTUAL_PHONE_NUMBER_INFO, ['ctm.safeinfo', 'ctm.safeinfo']],
    [UiEvent.RESULT_DELIVERY_MEMO_SELECT, ['ctm.click', 'ctm.click']],
    [UiEvent.RESULT_DELIVERY_MEMO_TEXTAREA, ['ctm.delmemo', 'ctm.delmemo']],
    [UiEvent.RESULT_DELIVERY_MEMO_REUSE_CHECKBOX, ['ctm.memosave', 'ctm.memosave']],
    /** 우편번호 검색 */
    [UiEvent.ORDERSHEET_ZIP_CODE_SEARCH_BUTTON, ['ode.zipsearch', 'ord.zipsearch']],
    [UiEvent.RESULT_ZIP_CODE_SEARCH_BUTTON, ['ctm.zipsearch', 'ctm.zipsearch']],
    [UiEvent.EXTERNAL_ZIP_CODE_SEARCH_BUTTON, ['zipcode.zipsearch', 'zipcode.zipsearch']],
    [UiEvent.ORDERSHEET_ZIP_CODE_RESULT, ['ode.zipselect', 'ord.zipselect']],
    [UiEvent.RESULT_ZIP_CODE_RESULT, ['ctm.zipselect', 'ctm.zipselect']],
    [UiEvent.EXTERNAL_ZIP_CODE_RESULT, ['zipcode.zipselect', 'zipcode.zipselect']],
    [UiEvent.ORDERSHEET_ZIP_CODE_RESULT_PAGINATION, ['ode.zippage', 'ord.zippage']],
    [UiEvent.RESULT_ZIP_CODE_RESULT_PAGINATION, ['ctm.zippage', 'ctm.zippage']],
    [UiEvent.EXTERNAL_ZIP_CODE_RESULT_PAGINATION, ['zipcode.zippage', 'zipcode.zippage']],
    [UiEvent.ADDRESS_DELETE_CONFIRM_BUTTON, ['ode.addrchkdelete', 'ord.addrchkdelete']],
    [UiEvent.DELIVERY_VIRTUAL_PHONE_NUMBER_INFO_CLOSE_BUTTON, ['ode.safeclose', 'ord.safeclose']],
    /** 배너 클릭 이벤트 */
    [UiEvent.MEMBERSHIP_PLCC_BANNER_CLICK, ['ode.nhdcorderapply2', 'ord.nhdcorderapply2']],
    [UiEvent.SHINHAN_PARTNERSHIP_BANNER_CLICK, ['ode.crecardlinebanner', 'ord.crecardlinebanner']],
    /** 주문 실패 */
    [UiEvent.FAILURE_REORDER, ['fle.orderagain', 'fle.orderagain']],
    [UiEvent.FAILURE_GO_SHOPPING_HOME, ['fle.shophome', 'fle.shophome']],
    /** 대기열 */
    [UiEvent.WAITING_GO_BACK, ['ode.waitingback', 'ord.waitingback']],
])

export const resultNClicksMap = new Map<UiEventType, [string, string]>([
    [UiEvent.RESULT_LOGO, ['ctm.paylogo', 'ctm.paylogo']],
    [UiEvent.RESULT_HEADER_CART, ['ctm.gnbcart', 'ctm.gnbcart']],
    [UiEvent.RESULT_HEADER_SHOPPING_HOME, ['ctm.gnbshopping', 'ctm.gnbshopping']],
    [UiEvent.VIRTUAL_ACCOUNT_NUMBER, ['ctm.copyaccountnumber', 'ctm.copyaccountnumber']],
    [UiEvent.DELIVERY_CHANGE, ['ctm.change', 'ctm.change']],
    [UiEvent.DELIVERY_MEMO_CHANGE_BUTTON, ['ctm.memoedit', 'ctm.memoedit']],
    [UiEvent.ORDER_LIST, ['ctm.orderlist', 'ctm.orderlist']],
    [UiEvent.ORDER_NO, ['ctm.orderno', 'ctm.orderno']],
    [UiEvent.ORDER_ITEM_OPEN, ['ctm.itemopen', 'ctm.itemopen']],
    [UiEvent.ORDER_ITEM_FOLD, ['ctm.itemfold', 'ctm.itemfold']],
    [UiEvent.ORDER_DETAIL, ['ctm.orderdetail', 'ctm.orderdetail']],
    [UiEvent.TIMELINE, ['ctm.timeline', 'ctm.timeline']],
    [UiEvent.PAY_NOW, ['ctm.pay', 'ctm.pay']],
    [UiEvent.ACCUMULATE_POINT_OPEN_REVIEW_TOOLTIP, ['ctm.revinfo', 'ctm.reviewbenefit']],
    [UiEvent.PRODUCT_NAME, ['ctm.image', 'ctm.product']],
    [UiEvent.PRODUCT_THUMBNAIL, ['ctm.name', 'ctm.product']],
    [UiEvent.SHOPPING_MALL_NAME, ['ctm.shoptext', 'ctm.shoptext']],
    [UiEvent.ORDER_LIST_BUTTON, ['ctm.orderlist', 'ctm.buylst']],
    [UiEvent.SHOPPING_HOME_BUTTON, ['ctm.home', 'ctm.home']],
    // [UiEvent.AITEMS_INFO_MALL, ['ctm.ainfoc1', 'ctm.ainfoc1']],
    // [UiEvent.AITEMS_CATEGORY, ['ctm.aithemec1', 'ctm.aithemec1']],
    // [UiEvent.AITEMS_MALL, ['ctm.aitemsc1', 'ctm.aitemsc1']],
    // [UiEvent.AITEMS_REFRESH, ['ctm.airefreshc1', 'ctm.airefreshc1']],
    // [UiEvent.AITEMS_MORE, ['ctm.aimorec1', 'ctm.aimorec1']],
    // [UiEvent.AITEMS_PREV_PAGE, ['ctm.aibeforepage', 'ctm.aibeforepage']],
    // [UiEvent.AITEMS_NEXT_PAGE, ['ctm.ainextpage', 'ctm.ainextpage']],
    [UiEvent.GFD_BANNER_CLOSE, ['ctm.chrgebannerx', 'ctm.chrgebannerx']],
    [UiEvent.GFD_BANNER_WEEK_CLOSE, ['ctm.chrgebanner30x', 'ctm.chrgebanner30x']],
    /** 배송지 관리 */
    [UiEvent.RESULT_ADDRESS_BOOK_BACK_BUTTON, ['ctm.addrback', 'ctm.addrback']],
    [UiEvent.RESULT_ADDRESS_BOOK_ADD_BUTTON, ['ctm.addrnew', 'ctm.addrnew']],
    [UiEvent.RESULT_ADDRESS_BOOK_ADDRESS, ['ctm.addrselect', 'ctm.addrselect']],
    [UiEvent.RESULT_ADDRESS_BOOK_EDIT_BUTTON, ['ctm.addredit', 'ctm.addredit']],
    [UiEvent.RESULT_ADDRESS_BOOK_REGISTER_BUTTON, ['ctm.addrsave', 'ctm.addrsave']],
    [UiEvent.RESULT_ADDRESS_BOOK_DELETE_BUTTON, ['ctm.addrdelete', 'ctm.addrdelete']],
    [UiEvent.RESULT_ADDRESS_BOOK_SHOW_ALL_BUTTON, ['ctm.addrmore', 'ctm.addrmore']],
    [UiEvent.RESULT_ADDRESS_BOOK_CONFIRM_BUTTON, ['ctm.addrdone', 'ctm.addrdone']],
    [UiEvent.RESULT_ADDRESS_FORM_RECEIVER, ['ctm.addrname', 'ctm.addrname']],
    [UiEvent.RESULT_ADDRESS_FORM_PHONE_NUMBER, ['ctm.addrphone', 'ctm.addrphone']],
    [UiEvent.RESULT_ADDRESS_FORM_ADDITIONAL_PHONE_NUMBER, ['ctm.addrphoneadd', 'ctm.addrphoneadd']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_HOME, ['ctm.addrpresethome', 'ctm.addrpresethome']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_OFFICE, ['ctm.addrpresetoffice', 'ctm.addrpresetoffice']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_SCHOOL, ['ctm.addrpresetschool', 'ctm.addrpresetschool']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_FRIEND, ['ctm.addrpresetfriend', 'ctm.addrpresetfriend']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_FAMILY, ['ctm.addrpresetfamily', 'ctm.addrpresetfamily']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_MANUAL, ['ctm.addrpresetmanual', 'ctm.addrpresetmanual']],
    [UiEvent.RESULT_ADDRESS_FORM_SEARCH_ADDRESS, ['ctm.addrdelsearch', 'ctm.addrdelsearch']],
    [UiEvent.RESULT_ADDRESS_FORM_DETAIL_ADDRESS, ['ctm.addrdetail', 'ctm.addrdetail']],
    [UiEvent.RESULT_ADDRESS_FORM_SET_AS_PRIMARY_CHECKBOX, ['ctm.addrdefaultset', 'ctm.addrdefaultset']],
    [UiEvent.RESULT_ADDRESS_FORM_CONFIRM, ['ctm.addrcheck', 'ctm.addrcheck']],
    [UiEvent.RESULT_VIRTUAL_PHONE_NUMBER_CHECKBOX, ['ctm.safe', 'ctm.safe']],
    [UiEvent.RESULT_VIRTUAL_PHONE_NUMBER_INFO, ['ctm.safeinfo', 'ctm.safeinfo']],
    [UiEvent.RESULT_DELIVERY_MEMO_SELECT, ['ctm.click', 'ctm.click']],
    [UiEvent.RESULT_DELIVERY_MEMO_TEXTAREA, ['ctm.delmemo', 'ctm.delmemo']],
    [UiEvent.RESULT_DELIVERY_MEMO_REUSE_CHECKBOX, ['ctm.memosave', 'ctm.memosave']],
    /** 우편번호 검색 */
    [UiEvent.RESULT_ZIP_CODE_SEARCH_BUTTON, ['ctm.zipsearch', 'ctm.zipsearch']],
    [UiEvent.RESULT_ZIP_CODE_RESULT, ['ctm.zipselect', 'ctm.zipselect']],
    [UiEvent.RESULT_ZIP_CODE_RESULT_PAGINATION, ['ctm.zippage', 'ctm.zippage']],
    [UiEvent.DELIVERY_MEMO_DETAIL, ['ctm.seedelmemo', 'ctm.seedelmemo']],
    [UiEvent.ADDRESS_DELETE_CONFIRM_BUTTON, ['ode.addrchkdelete', 'ord.addrchkdelete']],
    [UiEvent.DELIVERY_VIRTUAL_PHONE_NUMBER_INFO_CLOSE_BUTTON, ['ode.safeclose', 'ord.safeclose']],
    /** 배너 */
    [UiEvent.MEMBERSHIP_GUIDE, ['ctm.membershipbanner3', 'ctm.membershipbanner3']],
    [UiEvent.MEMBERSHIP_ANNUAL_GUIDE, ['ctm.membershipbanner2', 'ctm.membershipbanner2']],
    [UiEvent.MEMBERSHIP_PROMOTION_GUIDE, ['ctm.membershipbanner1', 'ctm.membershipbanner1']],
    // 패밀리결제 유도 배너 멤버용
    [UiEvent.FAMILY_PAY_MEMBER, ['ctm.familypayformember', 'ctm.familypayformember']],
    // 패밀리결제 유도 배너 대표용
    [UiEvent.FAMILY_PAY_ORGANIZER, ['ctm.familypayfororganizer', 'ctm.familypayfororganizer']],
    // 패밀리결제 다시 알려주기
    [UiEvent.FAMILY_PAY_REQUEST, ['ctm.familypayrequest', 'ctm.familypayrequest']],
    // 공유하기_카톡
    [UiEvent.FAMILY_PAY_SHARE_KAKAO_TALK, ['ctm.fpsharekakaotalk', 'ctm.fpsharekakaotalk']],
    // 공유하기_문자
    [UiEvent.FAMILY_PAY_SHARE_SMS, ['ctm.fpsharesms', 'ctm.fpsharesms']],
    // 공유하기_톡톡
    [UiEvent.FAMILY_PAY_SHARE_TALK_TALK, ['ctm.fpsharetalktalk', 'ctm.fpsharetalktalk']],
    // 공유하기_닫기
    [UiEvent.FAMILY_PAY_SHARE_CLOSE, ['ctm.fpshareclose', 'ctm.fpshareclose']],
    // 공유하기_보내기
    [UiEvent.FAMILY_PAY_SHARE_CONFIRM, ['ctm.fpshareconfirm', 'ctm.fpshareconfirm']],
])
